export default __webpack_public_path__ + "static/media/benonuoha.881aa961.jpeg";